module.exports = __webpack_public_path__ + "img/members-bg-shape@tl.abe0fb7.svg";


//////////////////
// WEBPACK FOOTER
// ./static/img/members-bg-shape@tl.svg
// module id = G37R
// module chunks = 0